// src/mosules/redux/reducers/authReducer.js
const initialState = {
    user: null,
    isLoggedIn: false,
  };
  
  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LOGIN':
        return {
          ...state,
          // user: action.payload,
          isLoggedIn: true,
        };
      case 'LOGOUT':
        return initialState;
      default:
        return state;
    }
  };
  
  export default authReducer;
  